

















import {Vue, Component} from 'vue-property-decorator';
import FormItem from '@/components/Money/FormItem.vue';
import Button from '@/components/Button.vue';
import router from '@/router';

@Component({
  components: {Button, FormItem},
})
export default class EditLabel extends Vue {
  get currentTag() {
    return this.$store.state.currentTag
  }

  created() {
    const id = this.$route.params.id;
    this.$store.commit('fetchTags')
    this.$store.commit('setCurrentTag', id)
    if (!this.currentTag) {
      this.$router.replace('/404');
    }
  }

  updateTag(name: string) {
    if (this.currentTag) {
      this.$store.commit('updateTag', {id: this.currentTag.id, name: name})
    }
  }

  remove() {
    if (this.currentTag) {
      this.$confirm('此操作将永久删除该标签, 是否继续?', '海青记账提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('removeTag', this.currentTag.id)
      }).catch(() => {
      })
    }
  }

  save() {
    if (this.currentTag) {
      if(!this.currentTag.name || this.currentTag.name ===''){
        this.$message({
          type: 'warning',
          message: '当前的标签名为空，请重新输入'
        })
      } else if(this.$store.state.saveTagError === null){
        this.$store.commit('saveTags')
        this.$message.success('保存成功')
        router.back()
      }else if((this.$store.state.saveTagError.message)=== 'duplication'){
        this.$message({
          type: 'warning',
          message: '当前的标签名已存在，请重新输入'
        })
      }
    }
  }
}
